import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router'
import { isLoaded, isEmpty } from 'react-redux-firebase'
import Login from '../AppAuth/Login'
import ProjectHeader from '../ProjectHeader/ProjectHeaderContainer'
import Timesheet from '../Timesheet/TimesheetContainer'
import Projects from '../Projects/Projects'
import Spinner from '../Spinner/Spinner'

const HomeComponents = ({ auth }) => (
  <React.Fragment>
    <ProjectHeader />
    <Timesheet auth={auth} />
  </React.Fragment>
)

HomeComponents.propTypes = {
  auth: PropTypes.object
}

const AppHome = ({ auth }) => {
  if (!isLoaded(auth)) return <Spinner />
  if (isEmpty(auth)) return <Login />

  return (
    <main>
      <Switch>
        <Route exact path="/" component={HomeComponents} />
        <Route path="/projects" component={Projects} />
      </Switch>
    </main>
  )
}

AppHome.propTypes = {
  auth: PropTypes.object
}

export default connect(({ firebase: { auth } }) => ({ auth }))(AppHome)



// WEBPACK FOOTER //
// ./src/components/AppHome/AppHome.js